import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const INACTIVE_STATUSES = ['none', 'canceled', 'incomplete_expired', 'unpaid'];

export function RequiresSubscription({ children }) {
  const { user, loading: authLoading } = useAuth();
  const [subStatus, setSubStatus] = useState(null); // null = checking
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (authLoading || !user) return;

    // Platform admins bypass
    if (user.is_platform_admin) {
      setSubStatus('active');
      setChecking(false);
      return;
    }

    axios.get(`${API}/billing/subscription`)
      .then(r => {
        setSubStatus(r.data.status || 'none');
        setChecking(false);
      })
      .catch(err => {
        if (err.response?.status === 402) {
          setSubStatus('none');
        } else {
          setSubStatus('none');
        }
        setChecking(false);
      });
  }, [user, authLoading]);

  if (authLoading || checking) {
    return (
      <div className="min-h-screen bg-[#F8FAFB] flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#0097A7] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-sm text-[#4E6974]">Loading...</p>
        </div>
      </div>
    );
  }

  if (INACTIVE_STATUSES.includes(subStatus)) {
    return <Navigate to="/billing" replace />;
  }

  return children;
}
